import { getMakeAPI, Method } from '@golden/gdk-base';
const makeGolbalAPI = getMakeAPI('/');
const makeAPI = getMakeAPI('agent/v2');
const COMMON_API = {
    GET_GAMES: makeAPI(Method.GET, 'games')(),
    GET_ACTIVITY_TYPES: makeAPI(Method.GET, 'activity-types')(),
    GET_ACCOUNT_SEARCH: makeAPI(Method.GET, 'account/search')(),
    POST_IMAGE: makeAPI(Method.POST, '/images')()
};
const AUTH_API = {
    AGENT_LOGIN: makeAPI(Method.POST, 'login')(),
    AGENT_LOGOUT: makeAPI(Method.POST, 'logout')(),
    VALIDATE_AGENT_ACCOUNT: makeAPI(Method.GET, 'legal-account')()
};
const DOMAIN_API = {
    GET_DOMAINS: makeAPI(Method.GET, 'domains')(),
    GET_CHECK_DOMAIN: makeGolbalAPI(Method.GET, '/')(),
    GET_PROMO_DOMAINS: makeAPI(Method.GET, 'promo-domains')(),
    GET_PROMO_STAFFS_INFO: makeAPI(Method.GET, 'promo-domains/staffs-info')(),
    GET_PROMO_STAFF_URLS: makeAPI(Method.GET, 'promo-domains/staff-urls')()
};
const AGENT_INFO_API = {
    GET_AGENT_ME: makeAPI(Method.GET, 'me')(),
    PUT_AGENT_ME: makeAPI(Method.PUT, 'me')(),
    GET_AGENT_ME_INFO: makeAPI(Method.GET, 'me/info')(),
    GET_HOME: makeAPI(Method.GET, 'home')()
};
const USERS_API = {
    // PLAYERS
    GET_PLAYERS: makeAPI(Method.GET, 'players')(),
    GET_PLAYERS_SEARCH: makeAPI(Method.GET, 'players/search')(),
    GET_PLAYERS_INFO: makeAPI(Method.GET, 'players/{id}')(),
    PUT_PLAYERS_BUBBLE_ID: makeAPI(Method.PUT, 'players/{id}/bubble-id')(),
    POST_PLAYERS_BUBBLE_ID_VALIDATE: makeAPI(Method.POST, 'players/bubble-id/validate')(),
    PUT_PLAYERS_MEMO: makeAPI(Method.PUT, 'players/{id}/memo')(),
    // AGENTS
    GET_AGENTS_LAYER: makeAPI(Method.GET, 'layer-info/layer')(),
    GET_AGENTS: makeAPI(Method.GET, 'layer-info/{id}/children')(),
    GET_AGENTS_INFO: makeAPI(Method.GET, 'layer-info/{id}')(),
    POST_AGENTS_INFO: makeAPI(Method.POST, 'layer-info/agents')(),
    PUT_AGENTS_INFO: makeAPI(Method.PUT, 'layer-info/agents/{id}')(),
    // SUB_ACCOUNTS
    GET_SUB_ACCOUNTS: makeAPI(Method.GET, 'assistants')(),
    GET_SUB_ACCOUNTS_INFO: makeAPI(Method.GET, 'assistants/{id}')(),
    POST_SUB_ACCOUNTS_INFO: makeAPI(Method.POST, 'assistants')(),
    PUT_SUB_ACCOUNTS_INFO: makeAPI(Method.PUT, 'assistants/{id}')()
};
const REPORT_API = {
    // COMMISSION
    GET_COMMISSION: makeAPI(Method.GET, 'report/commission')(),
    GET_COMMISSION_COMMISSION_DETAIL: makeAPI(Method.GET, 'report/commission/commission')(),
    GET_COMMISSION_FEEDBACK_DETAIL: makeAPI(Method.GET, 'report/commission/feedback')(),
    GET_COMMISSION_PLATFORM_FEE_DETAIL: makeAPI(Method.GET, 'report/commission/platform-fee')(),
    GET_COMMISSION_RISK_ADJUSTMENT_DETAIL: makeAPI(Method.GET, 'report/commission/risk-adjustment')(),
    GET_COMMISSION_FINANCE_FEE_DETAIL: makeAPI(Method.GET, 'report/commission/finance-fee')(),
    GET_COMMISSION_FINANCE_FEE_DETAIL_DETAILS: makeAPI(Method.GET, 'report/commission/finance-fee/details')(),
    // BET
    GET_BET_AGENT: makeAPI(Method.GET, 'report/games/agent')(),
    GET_BET_PLAYER: makeAPI(Method.GET, 'report/games/player')(),
    GET_BET_PLAYER_DETAIL: makeAPI(Method.GET, 'report/games/player-detail')(),
    GET_BET_AGENT_EXPORT: makeAPI(Method.GET, 'export/report/games/agent/validate')(),
    // ACTIVITY
    GET_ACTIVITY_AGENT: makeAPI(Method.GET, 'report/activity/agent/{id}')(),
    GET_ACTIVITY_PLAYER: makeAPI(Method.GET, 'report/activity/player/{id}')(),
    GET_ACTIVITY_PLAYER_DETAIL: makeAPI(Method.GET, 'report/activity/player/{id}/summary')(),
    // LEADERBOARD
    GET_LEADERBOARD: makeAPI(Method.GET, 'leaderboard')(),
    // 各種活動
    GET_ACTIVITY_PLAYER_NEW_MEMBER_BONUS: makeAPI(Method.GET, 'report/activity/player/new-member-bonus')(),
    GET_ACTIVITY_PLAYER_RECOMMEND_FRIEND: makeAPI(Method.GET, 'report/activity/player/recommend-friends')(),
    GET_ACTIVITY_PLAYER_INVITE_FRIEND: makeAPI(Method.GET, 'report/activity/player/invite-friends')(),
    GET_ACTIVITY_PLAYER_UPGRADE_BONUS: makeAPI(Method.GET, 'report/activity/player/upgrade-bonus')(),
    GET_ACTIVITY_PLAYER_DAILY_SIGN_IN: makeAPI(Method.GET, 'report/activity/player/daily-sign-in')(),
    GET_ACTIVITY_PLAYER_WEEKLY_BONUS: makeAPI(Method.GET, 'report/activity/player/weekly-bonus')(),
    GET_ACTIVITY_PLAYER_BIRTHDAY_BONUS: makeAPI(Method.GET, 'report/activity/player/birthday-bonus')(),
    GET_ACTIVITY_PLAYER_MANUAL_EVENT: makeAPI(Method.GET, 'report/activity/player/manual-event')(),
    GET_ACTIVITY_PLAYER_NEW_YEAR_2023: makeAPI(Method.GET, 'report/activity/player/new-year-2023')(),
    GET_ACTIVITY_PLAYER_NEW_YEAR_2024: makeAPI(Method.GET, 'report/activity/player/new-year-2024')(),
    GET_ACTIVITY_PLAYER_NEW_YEAR_2025_DRAW: makeAPI(Method.GET, 'report/activity/player/snake-year-good-luck-draw')(),
    GET_ACTIVITY_PLAYER_NEW_YEAR_2025_RED_ENVELOPE: makeAPI(Method.GET, 'report/activity/player/snake-year-good-luck-red-envelope')(),
    GET_ACTIVITY_PLAYER_NEW_YEAR_2026_TICKET: makeAPI(Method.GET, 'report/activity/player/new-year/ticket')(),
    GET_ACTIVITY_PLAYER_NEW_YEAR_2026_RED_ENVELOPE: makeAPI(Method.GET, 'report/activity/player/new-year/red-envelope')(),
    GET_ACTIVITY_PLAYER_DRAGON_BOAT_FESTIVAL_2023: makeAPI(Method.GET, 'report/activity/player/dragon-boat-festival-2023')(),
    GET_ACTIVITY_PLAYER_DEPOSIT_BONUS: makeAPI(Method.GET, 'report/activity/player/deposit-bonus-2024')(),
    GET_ACTIVITY_PLAYER_UEFA_BUILDING_UP: makeAPI(Method.GET, 'report/activity/player/uefa-building-up')(),
    GET_ACTIVITY_PLAYER_UEFA_STARS: makeAPI(Method.GET, 'report/activity/player/uefa-stars')(),
    GET_ACTIVITY_PLAYER_WEEKLY_BONUS_DRAW: makeAPI(Method.GET, 'report/activity/player/weekly-bonus-draw')(),
    GET_ACTIVITY_PLAYER_DAILY_BONUS_DRAW: makeAPI(Method.GET, 'report/activity/player/daily-bonus-draw')(),
    GET_ACTIVITY_PLAYER_MANUAL_ACTIVITY_WALLET: makeAPI(Method.GET, 'report/activity/player/manual-activity-wallet')(),
    GET_ACTIVITY_PLAYER_GASH_STORE: makeAPI(Method.GET, 'report/activity/player/gash-store')(),
    // TRANSACTION
    GET_TRANSACTION_SUMMARY: makeAPI(Method.GET, 'report/finance/agents/{id}/summary')(),
    GET_TRANSACTION_AGENT: makeAPI(Method.GET, 'report/finance/agents/{id}/children/summary')(),
    GET_TRANSACTION_PLAYER: makeAPI(Method.GET, 'report/finance/agents/{id}/players/summary')(),
    GET_TRANSACTION_PLAYER_SUMMARY: makeAPI(Method.GET, 'report/finance/players/{id}/summary')(),
    GET_TRANSACTION_PLAYER_DEPOSIT_HISTORY: makeAPI(Method.GET, 'report/finance/players/{id}/deposit-history')(),
    GET_TRANSACTION_PLAYER_WITHDRAW_HISTORY: makeAPI(Method.GET, 'report/finance/players/{id}/withdraw-history')(),
    GET_TRANSACTION_AGENT_EXPORT: makeAPI(Method.GET, 'export/report/finance/agents/{id}/history/validate')(),
    GET_TRANSACTION_PLAYER_EXPORT: makeAPI(Method.GET, 'export/report/finance/players/{id}/history/validate')()
};
const ANNOUNCEMENT_API = {
    GET_ANNOUNCEMENT: makeAPI(Method.GET, 'announcements')(),
    POST_ANNOUNCEMENT_READ: makeAPI(Method.POST, 'announcements/read')(),
    POST_ANNOUNCEMENT_READ_ALL: makeAPI(Method.POST, 'announcements/read-all')(),
    GET_STAFF_ANNOUNCEMENT_ALL: makeAPI(Method.GET, 'staff-announcements/all')(),
    POST_STAFF_ANNOUNCEMENT_READ: makeAPI(Method.POST, 'staff-announcements/read')(),
    POST_STAFF_ANNOUNCEMENT_READ_ALL: makeAPI(Method.POST, 'staff-announcements/read-all')(),
    GET_STAFF_ANNOUNCEMENT: makeAPI(Method.GET, 'staff-announcements')(),
    POST_STAFF_ANNOUNCEMENT: makeAPI(Method.POST, 'staff-announcements')()
};
const NOTIFICATION_API = {
    GET_BANNER_NOTIFICATIONS: makeAPI(Method.GET, 'banner-notifications')(),
    GET_BANNER_NOTIFICATION_LINK: makeAPI(Method.GET, 'banner-notifications/{id}/action')()
};
const AGENT_DEPOSIT_API = {
    VERIFY_AGENT_DEPOSIT: makeAPI(Method.POST, 'deposits/verify')(),
    AGENT_DEPOSIT: makeAPI(Method.POST, 'deposits')(),
    REMATCH_AGENT_DEPOSIT: makeAPI(Method.POST, 'deposits/rematch')(),
    GET_AGENT_DEPOSIT_RESULT: makeAPI(Method.GET, 'deposits/{id}/result')(),
    GET_AGENT_DEPOSIT_FEE: makeAPI(Method.GET, 'deposits/fee')(),
    GET_AGENT_DEPOSIT: makeAPI(Method.GET, 'deposits')(),
    GET_AGENT_DEPOSIT_NEED_REAL_NAME_METHODS: makeAPI(Method.GET, 'deposit/need-real-name-methods')()
};
const WALLET_API = {
    GET_AGENT_WALLETS_SUMMARY: makeAPI(Method.GET, 'agent-wallets/summary/{account}')(),
    POST_AGENT_WALLETS_TRANSFER: makeAPI(Method.POST, 'agent-wallets/transfer')(),
    GET_AGENT_TRANSFER_HISTORY: makeAPI(Method.GET, 'agent-wallets/transfer-history')(),
    GET_AGENT_WALLETS_USER_AUTO_COMPLETE: makeAPI(Method.GET, 'agent-wallets/transfer/user-autocomplete')(),
    GET_AGENT_WALLETS_HISTORY: makeAPI(Method.GET, 'agent-wallets/self-history')(),
    GET_AGENT_WALLETS_DEPOSITS: makeAPI(Method.GET, 'agent-wallets/deposits')(),
    POST_AGENT_WALLETS_DEPOSITS: makeAPI(Method.POST, 'agent-wallets/deposits')(),
    GET_AGENT_WALLETS_DEPOSIT_METHODS: makeAPI(Method.GET, 'agent-wallets/deposits/methods')(),
    GET_AGENT_WALLETS_DEPOSIT_RESULT: makeAPI(Method.GET, 'agent-wallets/deposits/{id}/result')(),
    GET_AGENT_WALLETS_DEPOSIT_FEE: makeAPI(Method.GET, 'agent-wallets/deposits/fee')(),
    GET_AGENT_DEPOSIT_DOWNLOAD_LINK: makeAPI(Method.GET, 'agent-wallets/deposits/download_link')(),
    POST_REMATCH_DEPOSIT: makeAPI(Method.POST, 'agent-wallets/deposits/rematch')()
};
const BARRIER_API = {
    POST_BARRIER_DETECT: makeAPI(Method.POST, 'barrier/detect')()
};
export const AGENT_API = {
    ...COMMON_API,
    ...AUTH_API,
    ...DOMAIN_API,
    ...AGENT_INFO_API,
    ...USERS_API,
    ...REPORT_API,
    ...ANNOUNCEMENT_API,
    ...NOTIFICATION_API,
    ...AGENT_DEPOSIT_API,
    ...WALLET_API,
    ...BARRIER_API
};
//# sourceMappingURL=AgentAPI.js.map